import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import { deletePortfolioIdV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useDeletePortfolioMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<void, Error, number>({
		mutationFn: processResponse((id: number) => deletePortfolioIdV2(id)),
		onSuccess: (_data, id) => {
			queryClient.invalidateQueries({
				queryKey: PortfolioKeys.portfolioList(),
			});
			queryClient.removeQueries({
				queryKey: PortfolioKeys.portfolioDetail(id),
			});
		},
	});
};
